import { PayloadAction } from '@reduxjs/toolkit';

import {
    EBorrowerCitizenshipStatus,
    EBorrowerMaritalStatus,
    EGender,
    EStateOrRegion,
    IAddress,
    IPersonalDetails,
} from '../types';

export const personalDetailsReducers = {
    setMobile: (state, action: PayloadAction<string | undefined>): void => {
        state.personalDetails.mobilePhone = action.payload;
    },
    setEmail: (state, action: PayloadAction<string | undefined>): void => {
        state.personalDetails.email = action.payload;
    },
    setGender: (state, action: PayloadAction<EGender>): void => {
        state.personalDetails.gender = action.payload;
    },
    setAddressByIndex: (
        state,
        action: PayloadAction<{ index: number; address: IAddress }>
    ): void => {
        state.address.address[action.payload.index] = action.payload.address;
    },
    setResidencyStatus: (
        state,
        action: PayloadAction<EBorrowerCitizenshipStatus | undefined>
    ): void => {
        state.personalDetails.citizenshipStatus = action.payload;
        if (action.payload !== EBorrowerCitizenshipStatus.VISA_HOLDER) {
            state.personalDetails.visaNumber = undefined;
            state.personalDetails.visaExpiryDate = undefined;
        }
    },
    setMaritalStatus: (
        state,
        action: PayloadAction<EBorrowerMaritalStatus | undefined>
    ): void => {
        state.personalDetails.maritalStatus = action.payload;
    },
    setVisaNumber: (state, action: PayloadAction<number | undefined>): void => {
        state.personalDetails.visaNumber = action.payload;
    },
    setVisaExpiryDate: (
        state,
        action: PayloadAction<Date | undefined>
    ): void => {
        state.personalDetails.visaExpiryDate = action.payload;
    },
    setHasChildren: (state, action: PayloadAction<boolean>): void => {
        state.personalDetails.hasChildren = action.payload;
    },
    setNumberOfChildren: (
        state,
        action: PayloadAction<number | undefined>
    ): void => {
        state.personalDetails.numberOfChildren = action.payload;
    },
    setPersonalDetails: (
        state,
        action: PayloadAction<IPersonalDetails>
    ): void => {
        state.personalDetails = action.payload;
    },
    setBirthdate: (state, action: PayloadAction<Date | undefined>): void => {
        state.personalDetails.birthdate = action.payload;
    },
    setLicenseNumber: (
        state,
        action: PayloadAction<string | undefined>
    ): void => {
        state.personalDetails.licenseNumber = action.payload;
    },
    setLicenseState: (
        state,
        action: PayloadAction<EStateOrRegion | undefined>
    ): void => {
        state.personalDetails.licenseState = action.payload;
    },
    setLicenseExpiry: (
        state,
        action: PayloadAction<Date | undefined>
    ): void => {
        state.personalDetails.licenseExpiry = action.payload;
    },
    setLicenseType: (
        state,
        action: PayloadAction<string | undefined>
    ): void => {
        // stored as enum string
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state.personalDetails as any).licenseType = action.payload;
    },
    setLicenseVersionNumber: (
        state,
        action: PayloadAction<string | undefined>
    ): void => {
        state.personalDetails.licenseVersionNumber = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string | undefined>): void => {
        state.personalDetails.firstName = action.payload;
    },
    setMiddleName: (state, action: PayloadAction<string | undefined>): void => {
        state.personalDetails.middleName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string | undefined>): void => {
        state.personalDetails.lastName = action.payload;
    },
};
